import { getTemplateNavHeaderUtilityStyles } from './NavHeaderUtility.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="menu-label">  
  <div class="menu-label-wrapper">
    <slot></slot>
  </div>  
</div>
`
const TemplateMenuLabel = t

class MenuLabel extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderUtilityStyles().content.cloneNode(true))
    shadow.appendChild(TemplateMenuLabel.content.cloneNode(true))
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('MenuLabel connectedCallback')
  }

  static get observedAttributes() {
    return ['data']
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === 'data') {
      document.AscendAwesome?.LogManager?.logDebug('MenuLabel attributeChangedCallback', newValue)
    }
  }
}

if (!customElements.get('ts-navheader-utility-menu-label')) {
  customElements.define('ts-navheader-utility-menu-label', MenuLabel)
}
export { MenuLabel }
